<template>
    <Teleport to="body">
        <dialog class="bg:#493B29B2::backdrop {p:0;r:8px;bg:white}:modal" ref="dialog">
            <div class="outline:none flex flex:col overflow:hidden max-width:736 min-width:288 max-height:90dvh rel">
                <div class="rel header lh:24px px:30 py:32 f:gray800 font-lg font-weight:500 flex-shrink:0 bb:1|solid|gray300" v-if="$slots.header">
                    <slot name="header"></slot>
                </div>
                <div class="content text-align:justify max-height:600 flex:1 mx:32@md mx:16 my:24 overflow-y:auto overflow-x:hidden outline:none" ref="content">
                    <slot></slot>
                </div>
                <div class="footer py:32 flex-shrink:0 bt:1|solid|gray300" v-if="$slots.footer">
                    <slot name="footer"></slot>
                </div>
                <div class="abs w:20 h:20 bg:url(images/close_cross.svg)|center|no-repeat top:15 right:15 cursor:pointer" @click="close"></div>
            </div>
        </dialog>
    </Teleport>
</template>

<script setup>
    import { useScroll } from "vueuse";

    const content = ref();
    const dialog = ref();

    const { arrivedState } = useScroll(content);
    const { bottom } = toRefs(arrivedState);

    const close = () => dialog.value.close();

    const emit = defineEmits(["end"]);

    const open = () => dialog.value.showModal();

    defineExpose({ close, open });

    onMounted(() => {
        watch(bottom, (arrived) => {
            if (arrived) {
                emit("end");
            }
        });
    });
</script>
